module.exports = __webpack_public_path__ + "static/media/image_02.c951052b.jpg";